import type { ComponentDocMap } from './types'

/**
 * Prop documentation for `follow_up_prod_kpi` and `kpi_value_card`.
 * Keep in sync with FollowUpProdKpiProps in src/ui/uiConfig/anchorComponents/FollowUpProdKpi/FollowUpProdKpi.types.ts
 */
export const followUpProdKpiPropDocs: ComponentDocMap = {
  items: {
    description: 'KPI items shown in the card.',
    type: 'FollowUpProdKpiItem[]',
    example: '[{ title: "__Production", data_id: "production", unit: "MWh", decimals: 1 }]',
  },
  'items[].no_data_icon': { description: 'Icon shown when data is missing.', type: 'string' },
  'items[].bar': { description: 'Renders this KPI as a bar.', type: 'boolean' },
}
